import { render, staticRenderFns } from "./Aphrodite.vue?vue&type=template&id=7832c0c1&scoped=true&"
import script from "./Aphrodite.vue?vue&type=script&lang=js&"
export * from "./Aphrodite.vue?vue&type=script&lang=js&"
import style0 from "./Aphrodite.vue?vue&type=style&index=0&id=7832c0c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7832c0c1",
  null
  
)

export default component.exports